module.exports = __webpack_public_path__ + "img/logo-equis.c3839d55.svg";